import { ChunkTypesId } from '@common/constants/ChunkTypes';
import { IChunkModel } from '@common/models/Chunks/Chunk';
import { IChunksModel } from '@common/models/Chunks/Chunks';
import { IStudentLessonModel } from '@common/models/StudentLessons/Studentlesson';

interface FormValues {
	[key: number]: string;
}

const getChunksInitialValues = (
	chunksModel: IChunksModel,
	lessonModel: IStudentLessonModel,
	canBeForm: boolean,
) =>
	chunksModel.data.reduce((values, chunk: IChunkModel) => {
		if (!canBeForm) {
			return values;
		}
		if (chunk.chunk_type?.name === 'Student') {
			const unRejectedGrades = lessonModel.grades?.filter((grade) => !grade.reject_comment);

			values[chunk.id] = {
				gradebook_id: lessonModel.gradebook.id,
				chunk_id: chunk.id,
				student_url:
					unRejectedGrades?.find((grade) => grade.chunk_id === chunk.id)?.student_url || [],
				student_file:
					unRejectedGrades?.find((grade) => grade.chunk_id === chunk.id)?.student_file || [],
				annotate_file:
					unRejectedGrades?.find((grade) => grade.chunk_id === chunk.id)?.annotate_file || [],
			};
		}
		if (chunk.chunk_type?.name === 'Scorm') {
			values[chunk.id] = {
				gradebook_id: lessonModel.gradebook.id,
				chunk_id: chunk.id,
			};
		}
		if (chunk.chunk_type?.id === ChunkTypesId.dictaphone) {
			values[chunk.id] = {
				gradebook_id: lessonModel.gradebook.id,
				chunk_id: chunk.id,
				dictaphone_url:
					lessonModel.grades?.find((grade) => grade.chunk_id === chunk.id)?.dictaphone_url || [],
				dictaphone_file:
					lessonModel.grades?.find((grade) => grade.chunk_id === chunk.id)?.dictaphone_file || [],
			};
		}
		return values;
	}, {} as FormValues);

export default getChunksInitialValues;
